const AnnouncementBanner = require("./announcement-banner"),
  brick = require("./brick"),
  contactForm = require("./contact-form"),
  followflight = require("./followflight"),
  generalSearch = require("./general-search"),
  googleAnalytics = require("./google-analytics"),
  handicapParking = require("./handicap-parking"),
  index = require("./index"),
  login = require("./login"),
  SearchResultsPage = require("./SearchResultsPage"),
  Spinner = require("./Spinner"),
  stickyDatepicker = require("./sticky-datepicker")

export {
  AnnouncementBanner,
  brick,
  contactForm,
  followflight,
  generalSearch,
  googleAnalytics,
  handicapParking,
  index,
  login,
  SearchResultsPage,
  Spinner,
  stickyDatepicker,
}
